<template>
  <label :class="['ms-checkbox', { 'event-none': readOnly }]">
    <input
      type="checkbox"
      :value="value"
      class="ms-checkbox-control"
      :readOnly="readOnly"
      :checked="value"
      :disabled="disabled"
      v-on="listeners"
    />
    <span :class="['checkmark', { 'event-none': readOnly }]"></span>
    <span v-if="label" class="ms-checkbox--text">{{ label }}</span>
  </label>
</template>
<script>
export default {
  name: "msCheckbox",
  props: {
    value: {
      type: [Boolean, Number],
    },
    label: {
      default: null,
      type: String,
    },
    disabled: {
      default: false,
      type: [Boolean, Function],
    },
    readOnly: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    onFocus(e) {
      const me = this;
      me.focused = true;
    },
    onBlur(e) {
      const me = this;
      me.focused = false;
    },
  },
  data() {
    return {
      focused: false,
    };
  },
  computed: {
    listeners() {
      const me = this;
      return {
        click: (event) => {
          me.$emit("click", event);
        },
        input: (event) => {
          me.$emit("input", !me.value);
        },
        change: (event) => {
          me.$emit("change", me.value);
        },
        focus: (event) => {
          me.onFocus(event);
        },
        blur: (event) => {
          me.onBlur(event);
        },
      };
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/components/MsCheckbox.scss";
</style>